import Service from "./abstract/Service";

export default class AnnouncementService extends Service {
  /**
   * Dismiss an announcement for the current user (RR-330).
   *
   * Persisted server-side in announcement_user, so the dismissal survives a
   * new device and the forced logout RR-327 triggers.
   */
  dismiss(id) {
    return this.post(`${env.API_URL}/announcements/${id}/dismiss`);
  }
}
